import React from 'react';
import styled from 'styled-components';
import chromeLogo from 'images/shared/internet_explorer_not_supported_splash/chrome_logo.svg';
import firefoxLogo from 'images/shared/internet_explorer_not_supported_splash/firefox_logo.svg';
import edgeLogo from 'images/shared/internet_explorer_not_supported_splash/edge_logo.svg';
import safariLogo from 'images/shared/internet_explorer_not_supported_splash/safari_logo.svg';

const InternetExplorerNotSupportedSplash = () => (
  <Wrapper>
    <Modal>
      <h1>Browser Is Not Supported</h1>
      <p>
        It looks like you&apos;re using Internet Explorer, which is an old browser no longer
        supported by this website. For the best online browsing experience use Chrome, Firefox, Edge
        or Safari.
      </p>
      <BrowserLogos>
        <a href="https://www.google.com/chrome/">
          <Logo backgroundColor="#27AE60">
            <img src={chromeLogo} alt="google chrome logo" loading="lazy" />
          </Logo>
        </a>
        <a href="https://www.mozilla.org/en-US/firefox/new/">
          <Logo backgroundColor="#BB6BD9">
            <img src={firefoxLogo} alt="mozilla firefox logo" loading="lazy" />
          </Logo>
        </a>
        <a href="https://www.microsoft.com/en-us/edge">
          <Logo backgroundColor="#fff">
            <img src={edgeLogo} alt="microsoft edge logo" loading="lazy" />
          </Logo>
        </a>
        <a href="https://support.apple.com/downloads/safari">
          <Logo backgroundColor="#2D9CDB">
            <img src={safariLogo} alt="apple safari logo" loading="lazy" />
          </Logo>
        </a>
      </BrowserLogos>
      <p>
        To learn more about why websites are dropping
        <br />
        support for Internet Explorer&nbsp;
        <a
          href="https://element5digital.com/why-wont-support-internet-explorer-and-neither-should-you/"
          target="_blank"
          style={{
            color: '#0090de'
          }}>
          click here
        </a>
        .
      </p>
    </Modal>
  </Wrapper>
);

const Wrapper = styled.div`
  background-color: #4db1e8;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: -0.5rem;
  left: -0.5rem;
`;

const BrowserLogos = styled.div`
  max-width: 35.375rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Logo = styled.div`
  width: 8rem;
  height: 8rem;
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 5.75rem;
  }
`;

const Modal = styled.div`
  align-items: center;
  background-color: #eeeeee;
  border-radius: 0.25rem;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 32.5rem;
  width: 53.5rem;
  margin-bottom: 16px;
  box-sizing: border-box;
  padding: 2.75em 0;

  h1 {
    font-family: adelle, serif;
    font-size: 2rem;
    margin: 0.25em auto 0;
  }

  p {
    line-height: 1.5rem;
    width: 35.375rem;
    text-align: center;
    margin: 0;
    font-family: 'proxima-nova', sans-serif;

    &:first-of-type {
      margin-bottom: 0.75em;
    }
  }
`;

export default InternetExplorerNotSupportedSplash;
